// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import { ConfigUtils } from './utils';
import { Dashboards, Instance, Scenario, ScenarioManager, DatasetManager, DataStore } from './views';

const DEFAULT_TABS = [
  {
    key: 'tabs.datastore.key',
    label: 'layouts.tabs.datastore.tab.title',
    to: 'datastore',
    render: <DataStore />,
  },
  {
    key: 'tabs.datasetmanager.key',
    label: 'layouts.tabs.datasetmanager.tab.title',
    to: 'datasetmanager',
    render: <DatasetManager />,
  },
  {
    key: 'tabs.scenario.key',
    label: 'layouts.tabs.scenario.tab.title',
    to: 'scenario',
    render: <Scenario />,
  },
  {
    key: 'tabs.scenariomanager.key',
    label: 'layouts.tabs.scenariomanager.tab.title',
    to: 'scenariomanager',
    render: <ScenarioManager />,
  },
  {
    key: 'tabs.instance.key',
    label: 'layouts.tabs.instance.tab.title',
    to: 'instance',
    render: <Instance />,
  },
  {
    key: 'tabs.dashboards.key',
    label: 'layouts.tabs.dashboards.tab.title',
    to: 'dashboards',
    render: <Dashboards />,
  },
];

export const getTabsForCurrentWorkspace = (currentWorkspaceData) => {
  return filterTabsForCurrentWorkspace([...DEFAULT_TABS], currentWorkspaceData);
};

export const filterTabsForCurrentWorkspace = (tabs, currentWorkspaceData) => {
  const hideDatastoreView = currentWorkspaceData?.webApp?.options?.datastoreView?.disabled === true;
  const hideInstanceView = !ConfigUtils.isInstanceViewConfigValid(currentWorkspaceData?.webApp?.options?.instanceView);
  const hideDatasetManager = !ConfigUtils.isDatasetManagerEnabledInWorkspace(currentWorkspaceData);
  const hideDashboardsView = !ConfigUtils.isResultsDisplayEnabledInWorkspace(currentWorkspaceData);

  return tabs.filter((tab) => {
    if (
      (hideDatastoreView && tab.key === 'tabs.datastore.key') ||
      (hideInstanceView && tab.key === 'tabs.instance.key') ||
      (hideDatasetManager && tab.key === 'tabs.datasetmanager.key') ||
      (hideDashboardsView && tab.key === 'tabs.dashboards.key')
    )
      return false;
    return true;
  });
};

export const getAllTabs = () => {
  return DEFAULT_TABS;
};
